import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { formatDateKo } from '@/lib/format';

interface ShamanRow {
  id: string;
  slug: string;
  display_name_ko: string;
  is_active: boolean;
  created_at: string;
  subscription_status: string | null;
  next_charge_at: string | null;
}

export function AdminShamansPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['admin-shamans'],
    queryFn: async (): Promise<ShamanRow[]> => {
      const { data, error } = await supabase
        .from('admin_shaman_overview')
        .select('*')
        .order('created_at', { ascending: false });
      if (error) throw error;
      return data ?? [];
    },
  });

  if (isLoading) return <div className="text-ink-muted">불러오는 중…</div>;

  return (
    <div className="card space-y-3">
      <h1 className="text-2xl font-bold">무당 목록</h1>
      {!data?.length && <p className="text-ink-muted">아직 가입한 무당이 없습니다.</p>}
      <ul className="divide-y divide-ink-line">
        {data?.map((s) => (
          <li key={s.id} className="py-3 flex justify-between items-center">
            <div>
              <div className="font-semibold">{s.display_name_ko}</div>
              <div className="text-base text-ink-muted">/b/{s.slug}</div>
              <div className="text-base text-ink-muted">
                가입: {formatDateKo(s.created_at, 'yyyy.MM.dd')}
              </div>
            </div>
            <div className="text-right text-base">
              <div>{s.subscription_status ?? '미가입'}</div>
              {s.next_charge_at && (
                <div className="text-ink-muted">
                  다음: {formatDateKo(s.next_charge_at, 'MM.dd')}
                </div>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
